import React from 'react'

import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'
import { Separator } from '@/shared/components/atoms/Separator'
import {
	Dialog,
	DialogContent,
	DialogTitle,
} from '@/shared/components/molecules/Dialog/dialog'

import { User } from './Users.types'

interface RemoveUserModalProps {
	visible: boolean
	user: User | null
	onClose: () => void
	onConfirm: () => void
	isLoading?: boolean
}

const RemoveUserModal: React.FC<RemoveUserModalProps> = ({
	visible,
	user,
	onClose,
	onConfirm,
	isLoading = false,
}) => {
	const { t } = useTranslation('common')

	const handleConfirm = () => {
		onConfirm()
	}

	return (
		<Dialog open={visible} onOpenChange={onClose}>
			<DialogContent
				className="sm:max-w-[500px] p-0 gap-0"
				showCloseButton={false}
			>
				<div className="px-6 py-6">
					<DialogTitle className="text-base font-semibold mb-1.5">
						{t('account.users.modals.remove.title')}
					</DialogTitle>
					<p className="text-sm text-muted-foreground">
						{t('account.users.modals.remove.description', { name: user?.name })}
					</p>
				</div>

				<Separator />

				<div className="px-6 py-6 flex justify-end gap-3">
					<Button
						variant="outline"
						onClick={onClose}
						className="rounded-full px-6"
						disabled={isLoading}
					>
						{t('account.users.modals.remove.cancel')}
					</Button>
					<Button
						variant="destructive"
						onClick={handleConfirm}
						className="rounded-full px-6"
						disabled={isLoading}
					>
						{isLoading
							? t('account.users.modals.remove.removing')
							: t('account.users.modals.remove.remove_user')}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	)
}

export default RemoveUserModal
